export default __webpack_public_path__ + "static/media/L0001.21d2a200.png";